import React, {Component} from 'react';
import { connect } from 'react-redux';
import {totalAvailableSpots, getRunOffsImages} from '../utils';
import BookingOpenAlert from './BookingOpenAlert';
import {goToParkingHome} from '../actions/navOptions';
import SpotReservationNotice from '../components/SpotReservationNotice';

class IntroMessage extends Component {

  render() {
    const {firstName} = this.props;
    const spotsAvailable = totalAvailableSpots();
    const [RunOffsImage, RunOffsImage2] = getRunOffsImages();

    return (
      <div className="map-page-content" id="message-intro">
        <BookingOpenAlert />
        <img src={RunOffsImage2} srcSet={`${RunOffsImage2} 1x, ${RunOffsImage2} 2x`} alt="" />
        <h2>{`Welcome ${firstName}!`}</h2>
        <p>{`Choose a spot from ${spotsAvailable} available`}</p>
        <SpotReservationNotice />
        <a className="btn btn-primary btn-lg" onClick={goToParkingHome} >{`OK, let's go`}</a>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    firstName: state.user.firstName
  };
};

export default connect(mapStateToProps)(IntroMessage);



// WEBPACK FOOTER //
// ./src/containers/IntroMessage.js